import formTextField from "./field-validators/form-text-field";
import modernizedTextField from "./field-validators/modernized-text-field";
import formCheckboxContainer from "./field-validators/form-checkbox-container";
import photoPicker from "./field-validators/photo-picker";
import listItemWrapper from "./field-validators/list-item-wrapper";
import slider from "./field-validators/slider";
import formDateTimePicker from "./field-validators/form-date-time-picker";
import dateTimePicker from "./field-validators/date-time-picker";
import formCalendarPicker from "./field-validators/form-calendar-picker";
import cellWithCheckMultiple from "./field-validators/cell-with-check-multiple";
import formImage from "./field-validators/form-image";
import formCalendarPickerSlots from "./field-validators/form-calendar-picker-slots";
import formTextView from "./field-validators/form-text-view";
import controllers from "../screens/controllers";
import formRadioButtons from "./field-validators/form-radio-buttons";
import fieldWithActionEventStates from "./field-validators/field-with-action-event-states";
import modernizedPhoneNumber from "./field-validators/modernized-phone-number";

export const setFieldsErrorsFromBack = appData => {
  const {
    data: { errors },
    screenValidation: { fields },
    setFormErrorsFromBack,
    setFieldValidation
  } = appData;

  // set form errors from back end
  if (errors && errors.length) {
    const fieldsErrors = errors.reduce((res, err) => {
      const field = fields.find(
        fieldItem => fieldItem.fieldName === err.fieldName
      );

      if (field) {
        res[field.fieldName] = {
          ...field,
          isValid: false,
          errorMessage: err.errorMessage
        };
      }

      return res;
    }, {});

    setFormErrorsFromBack({ errors: [] });
    setFieldValidation(fieldsErrors);
  }
};

export const isFieldsValid = appData => {
  const invalidFields = appData.screenValidation.fields.filter(
    f => f.fieldName && !f.isValid
  ); // skip validation for fields without a name because we can't track them

  if (invalidFields?.[0]?.scrollToField) {
    invalidFields[0].scrollToField(appData.isUnifiedRegistration);
  }

  if (invalidFields.length) {
    invalidFields.forEach(field => {
      appData.setFieldValidation({
        [field.fieldName]: field
      });
    });
    appData.setFormGroupErrors(invalidFields);

    appData.screenValidation.validationMessage = invalidFields[0].errorMessage;
  } else {
    appData.resetValidation();
    appData.screenValidation.validationMessage = "";
  }

  return !invalidFields.length;
};

export const fieldValidation = Object.entries({
  formTextField,
  modernizedTextField,
  modernizedPhoneNumber,
  formCheckboxContainer,
  photoPicker,
  listItemWrapper,
  slider,
  formDateTimePicker,
  formCalendarPicker,
  cellWithCheckMultiple,
  formImage,
  formCalendarPickerSlots,
  formTextView,
  formRadioButtons,
  container: fieldWithActionEventStates,
  text: fieldWithActionEventStates,
  dateTimePicker
}).reduce(
  (result, [key, value]) => ({
    ...result,
    [key]: {
      ...value,
      update: (field, appData, extraData) => {
        const { data: { screens } = {}, screenIndex } = appData;
        const controllerName = screens?.[screenIndex]?.osController?.iOS;
        const controller =
          controllers[controllerName] || controllers.BaseViewController;
        const fieldObject = (
          controller.fieldValidation?.[key]?.update ?? value.update
        )(field, appData, extraData);

        if (
          fieldObject &&
          fieldObject.fieldName &&
          fieldObject.fieldName === appData.validation.fieldName &&
          fieldObject.isValid
        ) {
          appData.resetValidation();
        }

        if (fieldObject) {
          fieldObject.scrollToField = scrollToField(extraData?.fieldRef);
        }

        return fieldObject;
      }
    }
  }),
  {}
);

const scrollToField =
  fieldRef =>
  (needFocus = false) => {
    const fieldElement = fieldRef?.current;
    if (fieldElement) {
      if (needFocus) {
        const innerInput = fieldElement.querySelector("input");
        if (innerInput) {
          innerInput.focus();
        }
      }
      if (fieldElement.scrollIntoView) {
        fieldElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };
